import axiosClient from './axiosClient';
import { TicketReopenReasonModel } from '../Models/ticketReopenReasonModel';

const ticketReopenReasonService = {
  getAll: () => {
    return axiosClient.get('/TicketReopenReason')
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("GET /TicketReopenReason returned 404. Falling back to GET /ticket-reopen-reasons...");
          return axiosClient.get('/ticket-reopen-reasons');
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const rawList = res?.data?.data || res?.data || [];
        const mappedList = (Array.isArray(rawList) ? rawList : []).map(TicketReopenReasonModel.toFrontend);
        return {
          data: mappedList,
        };
      });
  },

  getById: (id) => {
    return axiosClient.get(`/TicketReopenReason/${id}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`GET /TicketReopenReason/${id} returned 404. Falling back to GET /ticket-reopen-reasons/${id}...`);
          return axiosClient.get(`/ticket-reopen-reasons/${id}`);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: TicketReopenReasonModel.toFrontend(raw),
        };
      });
  },

  create: (payload) => {
    const body = TicketReopenReasonModel.toBackend(payload);
    body.reopenReasonId = 0;

    return axiosClient.post('/TicketReopenReason', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("POST /TicketReopenReason returned 404. Falling back to POST /ticket-reopen-reasons...");
          return axiosClient.post('/ticket-reopen-reasons', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: TicketReopenReasonModel.toFrontend(raw),
        };
      });
  },

  update: (id, payload) => {
    const body = TicketReopenReasonModel.toBackend({ ...payload, reopenReasonID: id });

    return axiosClient.put('/TicketReopenReason', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("PUT /TicketReopenReason returned 404. Falling back to PUT /ticket-reopen-reasons...");
          return axiosClient.put('/ticket-reopen-reasons', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: TicketReopenReasonModel.toFrontend(raw),
        };
      });
  },

  remove: (id) => {
    return axiosClient.delete(`/TicketReopenReason/${id}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`DELETE /TicketReopenReason/${id} returned 404. Falling back to DELETE /ticket-reopen-reasons/${id}...`);
          return axiosClient.delete(`/ticket-reopen-reasons/${id}`);
        }
        return Promise.reject(err);
      });
  },
};

export default ticketReopenReasonService;
